var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRockTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.5,61.5l7.5-3,7.5-5.5,6-2,5-6v-4l-3-7v-7.5l-3-4-8-4.5-17,3.5-6.5,3-4,2-4,4h-3l-12,8,1,4-1,3.5,3.5,3h6.5l3.5,4.5,21,8Zm0,0l2.5-7,2-7-4-9.5,5-10,7.5-9m-5.5,15v5c0,.8,1.67,2.67,2.5,3.5l1.5,2v2.5l-1,4m2.5-26l4.5,6v8l3,5m-28-3v4l-4.5,4.5m2-17l-6.5,1.5-3,3.5-1.5,2.5-7,3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockTooltip);
export default __webpack_public_path__ + "static/media/rock_tooltip.cb2455e5b286daac4e967f2abab25cbc.svg";
export { ForwardRef as ReactComponent };